import React from 'react';

interface AvatarProps {
  src?: string | null;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Avatar component with automatic fallback to initials
 * Handles broken images and missing avatars gracefully
 */
const Avatar: React.FC<AvatarProps> = ({ src, name, size = 'md', className = '' }) => {
  const [imageError, setImageError] = React.useState(false);
  
  // Size classes
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
  };
  
  // Get first letter of name (uppercase)
  const initial = name.charAt(0).toUpperCase();
  
  // Show initials if no src, image error, or src is empty
  const showInitials = !src || imageError || src.trim() === '';
  
  if (showInitials) {
    return (
      <div 
        className={`${sizeClasses[size]} rounded-full bg-blue-600 text-white flex items-center justify-center font-medium ${className}`}
        title={name}
      >
        {initial}
      </div>
    );
  }
  
  return (
    <img 
      src={src} 
      alt={name}
      className={`${sizeClasses[size]} rounded-full object-cover ${className}`}
      onError={() => setImageError(true)}
      title={name}
    />
  );
};

export default Avatar;
